module.exports = __webpack_public_path__ + "static/media/importFlybook1.8f476e24.png";